import Url from "../utils/Url";

export const ACCOUNT_STATUS_ACTIVE = "active";
export const ACCOUNT_LOCKED = "ACCOUNT_LOCKED";
export const ACCOUNT_UNLOCKED = "ACCOUNT_UNLOCKED";
export const ACCOUNT_DEACTIVATED = "ACCOUNT_DEACTIVATED";
export const ACCOUNT_REACTIVATED = "ACCOUNT_REACTIVATED";
export const AGENT_ID_COOKIE_NAME = "agent_id";
export const BBG_COM_SITE_REGEX = Url.generateDomainRegex("bloomberg.com");
export const GOOGLE_NEWSSTAND_REGEX = Url.generateDomainRegex("google.com/psv");
export const CSRF_COOKIE_NAME = "_reg-csrf";
export const CSRF_TOKEN_COOKIE_NAME = "_reg-csrf-token";
export const EMAIL_OR_PASSWORD_ERROR = "EMAIL_OR_PASSWORD_ERROR";
export const FACEBOOK_ACCESS_TOKEN_COOKIE_NAME = "_fb-user-token";
export const FACEBOOK_ACCESS_TOKEN_FLAG_COOKIE_NAME = "_fb-user-token-flag";
export const INVALID_NEW_PASSWORD = "INVALID_NEW_PASSWORD";
export const LINKED_ACCOUNTS_COOKIE_NAME = "_linked-accounts";
export const REFERRAL_TOKEN_NOT_FOUND_ERROR = "REFERRAL_TOKEN_NOT_FOUND";
export const OBFUSCATED_URLS = {
    AUTHORIZE_APPLE_NEWS_BBG: "0bdc45ec31c24498daf0f7c358b74912",
    REGISTER_APPLE_BBG_SUBSCRIPTION: "7b2594e810e1260fcd5762afb6b027c6"
};
export const PARENT_DOMAIN = "bloomberg.com";
export const PAYMENT_METHODS = {
    STRIPE: "stripe",
    PAYPAL: "paypal",
    APPLE: "apple",
    GOOGLE: "google"
};
export const PROMO_NOT_ELIGIBLE = "PROMO_NOT_ELIGIBLE";
export const REDIRECT_AFTER_LOGIN_COOKIE_NAME = "_return-to";
export const SESSION_ID_COOKIE_NAME = "session_id";
export const SESSION_KEY_COOKIE_NAME = "session_key";
export const SHARED_USER_ID_COOKIE_NAME = "_breg-uid";
export const SHARED_USER_COOKIE_NAME = "_breg-user";
export const SHOW_SUCCESS_MESSAGE_COOKIE_NAME = "_show-success-message";
export const enum SOCIAL_MEDIA {
    FACEBOOK = "facebook",
    TWITTER = "twitter",
    APPLE = "apple",
    TERMINAL = "terminal"
}

export const SOCIAL_USER_NOT_FOUND = "SOCIAL_USER_NOT_FOUND";
export const SUBSCRIPTION_LAST_REFRESHED_COOKIE_NAME = "_last-refresh";
export const SUBSCRIPTIONS = "_subscriptions";
export const SUBSCRIPTIONS_DATA_COOKIE_NAME = "_subscriptions-data";
export const TWITTER_REQUEST_TOKEN_COOKIE_NAME = "_twtr-req-token";
export const TWITTER_TOKEN_COOKIE_NAME = "_twtr-user-token";
export const TWITTER_TOKEN_FLAG_COOKIE_NAME = "_twtr-user-token-flag";
export const TWITTER_TOKEN_SECRET_COOKIE_NAME = "_twtr-token-secret";
export const APPLE_AUTH_INFO_COOKIE_NAME = "_apple-auth-info";
export const APPLE_USER_INFO_COOKIE_NAME = "_apple-user-info";
export const APPLE_AUTH_INFO_FLAG_COOKIE_NAME = "_apple-auth-info-flag";
export const BSSO_ACCESS_TOKEN_COOKIE_NAME = "_bsso-user-token";
export const BSSO_ACCESS_TOKEN_FLAG_COOKIE_NAME = "_bsso-user-token-flag";
export const BSSO_STATE_COOKIE_NAME = "_bsso-state";
export const USER_ID_COOKIE_NAME = "_user-id";
export const USER_NEWSLETTERS_COOKIE_NAME = "_user_newsletters";
export const USER_ROLE_COOKIE_NAME = "_user-role";
export const USER_STATUS_COOKIE_NAME = "_user-status";
export const USER_TOKEN_COOKIE_NAME = "_user-token";
export const RATE_LIMIT_PER_MINUTE = 5;
export const ACCESSLIST_COOKIE_NAME = "_accesslist-membership";
export const ACCESSLIST_MEMBERS = {
    BLOOMBERG: "bloomberg",
    STUDENT: "student",
    VIASAT: "viasat"
};
export const GEOIP_COUNTRY_COOKIE = "_geoip_country";
export const REGION_COOKIE = "exp_pref";
export const SUBSCRIBER_DATA_COOKIE_NAME = "_subscriber-data";
export const UNKNOWN_ERROR_PREFIX = "An unknown error has occurred";
export const TIMEOUT_ERROR_PREFIX = "Your transaction timed out.";
export const SOCIAL_NO_EMAIL_ERROR_TYPE = "social_no_email";
export const TERMINAL_NON_BBA_ERROR_TYPE = "terminal_non_bba";
export const EMAIL_VERIFIED_MUST_LOGIN = "EMAIL_VERIFIED_MUST_LOGIN";
export const SERVER_TIMEOUT = "Server timeout";
export const SERVER_TIMEOUT_USER_FRIENDLY = "Submission failed. Please try again.";
export const BULK_SUBSCRIPTIONS_PVF_LEVEL = "PVF_BBGSUBS_1";
export const PVF_LEVELS_COOKIE_NAME = "pvf_levels";
export const JWT_SIGNING_ALGORITHM = "RS256";
export const SCREENS = {
    ACCOUNT: "/settings",
    COUNTER_OFFER: "/full-price-offers",
    PROFESSION: "/profession",
    SIGNUP: "/signup",
    EMAIL_RESENT: "/email-resent",
    MANAGE_SUBSCRIPTION: "/manage-subscription",
    SIGN_IN: "/signin",
    ACTIVATION_EMAIL: "/activation-email",
    FORGOT_PASSWORD: "/forgot-password",
    REGISTER: "/register",
    SIGNUP_NEWSLETTERS: "/signup-newsletters",
    RESET_PASSWORD: "/reset-password",
    SET_PASSWORD: "/set-password",
    BULK_SUBSCRIPTION_PURCHASE_FORM: "/group-subscription-purchase-form",
    SUBSCRIPTION_PURCHASE_FORM: "/subscription-form",
    SUBSCRIPTIONS: "/subscriptions",
    SUBSCRIPTION_SUCCESS: "/subscription-success",
    SUBSCRIPTION_ACTIVATION_EMAIL: "/subscription-activation-email",
    NEWSLETTERS: "/newsletters",
    OFFERS: "/offers",
    OFFER_SUCCESS: "/offer-success",
    WATCHLIST: "/watchlist",
    STUDENT_DOCUMENT_UPLOAD: "/student-document-upload",
    ONBOARDING: "/onboarding"
};
export const ADMIN_BULK_SUBS_SCREENS = {
    CREATE_SUBSCRIPTION: "/bulk-subscriptions/create-new-subscription",
    LIST_SUBSCRIPTIONS: "/bulk-subscriptions",
    MANAGE_SUBSCRIPTION: "/bulk-subscriptions/manage-subscription/:id"
};
export const SUCCESS_MESSAGES = {
    FORM_FIELD_VALIDATED: "Form Field Validated."
};
export const FLOWS = {
    REGISTER: "register",
    RESET_PASSWORD: "reset_password"
};
export const THEMES = {
    ERROR_THEME_MODULE_LEVEL: "moduleLevel",
    ERROR_THEME_PAGE_LEVEL: "pageLevel"
};
export const ADDRESS_FIELDS = {
    FIRST_NAME: "firstName",
    LAST_NAME: "lastName",
    ADDRESS_LINE_1: "addressLine1",
    ADDRESS_LINE_2: "addressLine2",
    CITY: "city",
    STATE: "state",
    POSTAL_CODE: "postalCode",
    COUNTRY: "country"
};
export const SUBSCRIPTION_TYPES = {
    DIGITAL: "DIGITAL",
    ALL: "ALL",
    BULK: "BULK"
};
export enum OFFER_TYPES {
    GROUP = "GROUP",
    STUDENT = "STUDENT",
    SINGLE = "SINGLE"
}

export const WORKFLOW_STEPS = {
    BULK_SUBSCRIPTION: {
        CONFIRM_EMAIL: "CONFIRM_EMAIL",
        COMPANY_AND_ADMIN_INFO: "COMPANY_AND_ADMIN_INFO",
        PAYMENT_AND_BILLING: "PAYMENT_AND_BILLING",
        CONFIRMATION: "CONFIRMATION"
    },
    SUBSCRIPTION: {
        USER_INFO: "USER_INFO",
        STUDENT_VERIFICATION: "STUDENT_VERIFICATION",
        PAYMENT: "PAYMENT",
        SELECT_OFFER: "SELECT_OFFER",
        SHIPPING_ADDRESS: "SHIPPING_ADDRESS",
        CONFIRMATION: "CONFIRMATION"
    }
};
export const SUBSCRIPTION_FORM_TITLES = {
    PAYMENT: "Payment Method",
    BILLING_ADDRESS: "Billing Address",
    SHIPPING_ADDRESS: "Mailing Address"
};
export const BULK_SUBSCRIBER_TIERS = [ 10, 25, 50, 75, 100, 200, 500, 1000 ];
export const DEFAULT_BULK_SUBSCRIBER_TIER = "200";
export const enum BULK_SUBSCRIPTIONS_STATUS {
    PAUSED = "PAUSED",
    ACTIVE = "ACTIVE"
}

export const MIN_NUM_SELF_SERVE_BULK_SUBSCRIBERS = 2;
export const MAX_NUM_SELF_SERVE_BULK_SUBSCRIBERS = 5;
export const STRIPE_FONTS_URL = "https://assets.bwbx.io/font-service/css/BWHaasGrotesk-55Roman-Web/font-face.css";
export const FEEDBACK_URL = "https://www.bloomberg.com/feedback";
export const TERMS_OF_SERVICE_URL = "https://www.bloomberg.com/notices/tos/";
export const USER_STATUS_DEACTIVATED = "deactivated";
export enum SUBSCRIPTION_BILLING_PERIOD {
    MONTH = "Month",
    ANNUAL = "Annual",
    BIENNIAL = "Two_Years"
}

export const SUBSCRIPTION_BILLING_PERIOD_IN_MONTHS = new Map<SUBSCRIPTION_BILLING_PERIOD, number>([
    [SUBSCRIPTION_BILLING_PERIOD.MONTH, 1],
    [SUBSCRIPTION_BILLING_PERIOD.ANNUAL, 12],
    [SUBSCRIPTION_BILLING_PERIOD.BIENNIAL, 24]
]);

export const NORTH_DAKOTA_SUBSCRIPTION_LIMIT_IN_MONTHS = 24;
export enum SUBSCRIPTION_INTRO_PERIOD_STATUS {
    END_OF_INTRO = "end-of-intro",
    PAST_INTRO = "past-intro",
    BEGINNING_OF_INTRO = "beginning-of-intro"
}

export const BLOOMBERG_EMAIL_REGEX = /bloomberg\.net$/;
export const ABBA_CONFIGS = {
    UPSELL_OFFER: "upsell-offer",
    COUNTER_OFFERS: "counter-offers",
    REFERRALS_OPT_IN: "referrals-opt-in",
    SUBSCRIPTION_FORM: "subscription-form",
    SAVE_OFFERS: "save-offers",
    RATEPLAN_CHECKOUT:"rateplan-checkout"
};
export const enum ELOQUA_LEAD_SOURCE_VALUES {
    ALL_ACCESS = "All Access Subscription",
    DIGITAL = "Digital Subscription",
    STUDENT = "Student Subscription",
    GROUP = "Group Subscription",
    REGISTRATION_REGULAR = "registration - account",
    REGISTRATION_REG_WALL = "registration - reg wall",
    SOCIAL_LOGIN = "Social Login",
    NEWSLETTER = "Newsletter",
    UNKNOWN = "Unknown Subscription"
}

export const enum ELOQUA_VERIFIED_STATUS {
    VERIFIED = "verified",
    UNVERIFIED = "unverified"
}

export const ELOQUA_ABANDONED_CART_STATUS = {
    SUBSCRIBE_STARTED: "Subscribe Started",
    SUBSCRIBE_SUCCESS: "Subscribe Success"
} as const;
export const OPTIMIZELY_CUSTOM_EVENTS = {
    SUBSCRIPTION_SUCCESS: "subscriptionSuccess"
};
export const STATUS_CANCELLED = "Cancelled";
export const STATUS_EXPIRED = "Expired";
export const STATUS_INACTIVE = "Inactive";
export const STATUS_ACTIVE = "Active";
export const STATUS_PAUSED = "Paused";
export const STATUS_PENDING = "Pending";
export const SUBSCRIPTION_PERIODS = {
    WEEK: "week",
    MONTH: "month",
    YEAR: "annual",
    SIX_MONTHS: "semi_annual",
    QUARTER: "quarter",
    TWO_YEARS: "two_years",
    THREE_YEARS: "three_years",
    FOUR_YEARS: "four_years",
    FIVE_YEARS: "five_years"
};

/*
 * For all-access we don't want to collect billing country/state because we don't want to bog down the user with extra inputs.
 * In the all-access context, we don't need billing country/state for anything besides making billing zip code required/optional
 * which we also don't place a high priority on because billing zip is only used for stripe verification.
 */
export const SUBSCRIPTION_FORM_BILLING_ADDRESS_FIELDS = {
    [SUBSCRIPTION_TYPES.ALL]: [
        ADDRESS_FIELDS.POSTAL_CODE
    ],
    [SUBSCRIPTION_TYPES.DIGITAL]: [
        ADDRESS_FIELDS.COUNTRY,
        ADDRESS_FIELDS.STATE,
        ADDRESS_FIELDS.POSTAL_CODE
    ]
};
export const SUBSCRIPTION_FORM_SHIPPING_ADDRESS_FIELDS = {
    [SUBSCRIPTION_TYPES.ALL]: [
        ADDRESS_FIELDS.FIRST_NAME,
        ADDRESS_FIELDS.LAST_NAME,
        ADDRESS_FIELDS.ADDRESS_LINE_1,
        ADDRESS_FIELDS.ADDRESS_LINE_2,
        ADDRESS_FIELDS.CITY,
        ADDRESS_FIELDS.COUNTRY,
        ADDRESS_FIELDS.STATE,
        ADDRESS_FIELDS.POSTAL_CODE
    ],
    [SUBSCRIPTION_TYPES.DIGITAL]: []
};
export const ADDRESS_VALIDATION_FIELDS = [
    ADDRESS_FIELDS.ADDRESS_LINE_1,
    ADDRESS_FIELDS.CITY,
    ADDRESS_FIELDS.COUNTRY,
    ADDRESS_FIELDS.STATE
];
export const BACKEND_PATHS = {
    REACTIVATE_ACCOUNT: "/reactivate-account",
    UNLOCK_ACCOUNT: "/unlock-account",
    VALIDATE_EMAIL: "/validate-email"
};
export const NO_REFERRAL = "NO_REFERRAL";
export const TOKEN_STATUS = {
    ACTIVE: "ACTIVE",
    EXPIRED: "EXPIRED",
    EXCEEDED_REDEMPTION_LIMIT: "EXCEEDED_REDEMPTION_LIMIT"
};
export const PROMOTION_TYPES = {
    PROMO_START_WITH_BLOOMBERG: "PROMO_START_WITH_BBG",
    PROMO_START_WITH_PARTNER: "PROMO_START_WITH_PARTNER",
    INTRO_OFFER: "INTRO_OFFER",
    UPSELL_OFFER: "UPSELL_OFFER",
    SAVE_OFFER: "SAVE_OFFER",
    FREE_TRIAL: "FREE_TRIAL",
    WINBACK: "WINBACK",
    NONE: "NONE"
};
export const enum REFERRAL_SHARING_PREFERENCES {
    OPT_IN = "OPT_IN",
    OPT_OUT = "OPT_OUT",
    DEFAULTED_OPT_OUT = "DEFAULTED_OPT_OUT"
}

export const REFERRAL_OPT_IN_VARIATIONS = {
    AUTO: "auto",
    MANUAL: "manual",
    SILENT: "silent",
    NONE: "none"
};
export const STRIPE_CARD_FUNDING_TYPES = {
    CREDIT: "credit",
    DEBIT: "debit",
    PREPAID: "prepaid",
    UNKNOWN: "unknown"
};
export const EXPECTED_ERROR_TYPES = [
    EMAIL_OR_PASSWORD_ERROR,
    ACCOUNT_LOCKED,
    ACCOUNT_DEACTIVATED,
    PROMO_NOT_ELIGIBLE,
    REFERRAL_TOKEN_NOT_FOUND_ERROR
];
export const LOCATION_CHANGE_ACTIONS = {
    POP: "POP"
};

export const enum ACCOUNT_ERROR_STATUS {
    LOCKED = "locked",
    DEACTIVATED = "deactivated"
}
